import gql from 'graphql-tag';
import FieldsTeam from "graphql/fields/FieldsTeam";

export default gql(`
	query teams {
		teams {
			${FieldsTeam}
		}
	}
`);

